import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SidebarLayout from '@/components/SidebarLayout';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    useLocation().state?.user ? true : null
  );
  const [user, setUser] = useState(useLocation().state?.user || null);
  const [subscriptionChecked, setSubscriptionChecked] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.user) {
      setIsAuthenticated(true);
      setUser(location.state.user);
      checkSubscription(location.state.user);
      return;
    }

    const checkAuth = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/auth/me`, {
          credentials: 'include'
        });
        
        if (!response.ok) throw new Error('No autenticado');
        
        const userData = await response.json();
        const role = userData.account_role || userData.role;

        // Comisionistas tienen su propio layout
        if (role === 'comisionista') {
          navigate('/portal-comisionista');
          return;
        }

        setIsAuthenticated(true);
        setUser(userData);
        checkSubscription(userData);
      } catch {
        setIsAuthenticated(false);
        navigate('/login');
      }
    };
    
    checkAuth();
  }, [navigate, location.state]);

  const checkSubscription = async (userData) => {
    // Solo el OWNER debe validar suscripción.
    // Admin, viewer, editor invitados al equipo NUNCA son bloqueados.
    const role = userData.account_role || userData.role;
    if (role && role !== 'owner') {
      setSubscriptionChecked(true);
      return;
    }

    try {
      const response = await fetch(`${BACKEND_URL}/api/subscription/status`, {
        credentials: 'include'
      });
      
      if (!response.ok) {
        // Si falla el check, NO bloquear al usuario (fail-open)
        setSubscriptionChecked(true);
        return;
      }

      const subData = await response.json();
      
      // Redirigir a paywall solo si:
      // - Suscripción NO está activa
      // - Y no estamos ya en /subscription
      if (!subData.is_active && location.pathname !== '/subscription') {
        navigate('/subscription');
        return;
      }
    } catch {
      // Error de red: NO bloquear (fail-open)
      console.error('Subscription check failed - allowing access');
    }
    setSubscriptionChecked(true);
  };

  if (isAuthenticated === null || !subscriptionChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-amber-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-zinc-400">Cargando...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <SidebarLayout user={user}>{children}</SidebarLayout> : null;
};

export default ProtectedRoute;
